export const RESERVED_PROPS = [
  'innerRef',
  'tag',
  'block',
  'label',
  'children',
  'beforeContent',
  'afterContent',

  'equalCols',
  'vertical',
  'direction',
  'alignX',
  'alignY',

  'css',
  'contentCss',
  'beforeContentCss',
  'afterContentCss',

  'contentDirection',
  'contentAlignX',
  'contentAlignY',

  'beforeContentDirection',
  'beforeContentAlignX',
  'beforeContentAlignY',

  'afterContentDirection',
  'afterContentAlignX',
  'afterContentAlignY',
] as const

export const INLINE_ELEMENTS = {
  span: true,
  a: true,
  button: true,
  input: true,
  label: true,
  select: true,
  textarea: true,
  br: true,
  img: true,
  strong: true,
  small: true,
  code: true,
  b: true,
  big: true,
  i: true,
  tt: true,
  abbr: true,
  acronym: true,
  cite: true,
  dfn: true,
  em: true,
  kbd: true,
  samp: true,
  var: true,
  bdo: true,
  map: true,
  object: true,
  q: true,
  script: true,
  sub: true,
  sup: true,
}

export const EMPTY_ELEMENTS = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  textarea: true,
  // 'meta': true,
  // 'param': true,
  source: true,
  track: true,
  wbr: true,
}
